export enum EMPLOYEE_VACATIONS {
  FOUR_WEEKS = "FOUR_WEEKS",
  FIVE_WEEKS = "FIVE_WEEKS",
  SIX_WEEKS = "SIX_WEEKS",
}
